export function isLocal(): boolean {
    return window.location.hostname === 'localhost';
}

export const currentEnvironment: string = import.meta.env.VITE_APP_ENVIRONMENT || '';

export function isProduction(): boolean {
    return window.location.hostname === 'platform.remotely.works';
}

export function isStaging(): boolean {
    return !isLocal() && !isProduction();
}

export function isDisable2FA(): boolean {
    return import.meta.env.VITE_DISABLE_2FA === 'true' && isLocal();
}

export function isE2ETest(): boolean {
    return import.meta.env.VITE_IS_E2E_TEST === 'true';
}

export function isVisualRegression(): boolean {
    return import.meta.env.VITE_IS_VISUAL_REGRESSION === 'true';
}
